enum DashboardTabs {
  RISKS = 'Risks',
  ASSESSMENTS = 'Assessments',
  REVIEWS = 'Reviews',
}

export default DashboardTabs;
